import { render, staticRenderFns } from "./ModalDeliveryList.vue?vue&type=template&id=8dbfcba6&"
import script from "./ModalDeliveryList.vue?vue&type=script&lang=js&"
export * from "./ModalDeliveryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports